<template>
  <div
    class="nationality-list-item"
    :class="{ 'nationality-list-item--highlighted': highlighted }"
    @mouseenter="$emit('hover', nationality.name)"
    @mouseleave="$emit('hover', null)"
  >
    <span class="nationality-list-item__dot" :style="{ background: highlighted ? nationality.hoverColor || nationality.color : nationality.color }"></span>
    <span class="nationality-list-item__name">{{ nationality.name }}</span>
    <span class="nationality-list-item__count">{{ nationality.count }}</span>
    <span class="nationality-list-item__percent">{{ percentLabel }}</span>
  </div>
</template>

<script>
export default {
  name: 'NationalityListItem',
  props: {
    // { name, count, percent (unrounded), color, hoverColor }
    nationality: {
      type: Object,
      required: true,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Whole percentages, except small shares that would otherwise round down to 0%
    percentLabel() {
      const { percent } = this.nationality
      return percent > 0 && percent < 1 ? '<1%' : `${Math.round(percent)}%`
    },
  },
}
</script>

<style scoped>
.nationality-list-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e6e6e6;
  font-size: 12px;
  color: #333;
  transition: background-color 0.15s ease;
}

.nationality-list-item--highlighted {
  background-color: #f6f5f3;
}

.nationality-list-item__dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  transition: transform 0.15s ease;
}

.nationality-list-item--highlighted .nationality-list-item__dot {
  transform: scale(1.5);
}

.nationality-list-item--highlighted .nationality-list-item__name {
  font-weight: 600;
  color: #1a1a1a;
}

.nationality-list-item__name {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nationality-list-item__count {
  flex: 0 0 40px;
  text-align: right;
  font-weight: 700;
  color: #1a1a1a;
}

.nationality-list-item__percent {
  flex: 0 0 50px;
  text-align: right;
  color: #8a8a8a;
}
</style>
